import React from "react";
import { useTranslation } from "react-i18next";
import { CheckCircleIcon } from "./icons";
import { BotCheckState } from "./types";

export interface StepIndicatorProps {
  current: number;
  total: number;
  botCheckState: BotCheckState;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  current,
  total,
  botCheckState,
}) => {
  const { t } = useTranslation("flightAlerts");
  return (
    <div className="flex flex-col gap-3">
      {botCheckState === "checked" && current === 2 && (
        // Figma spec: rounded-xl (12px), 12px padding, 8px gap, success/tint
        // background, success/ink icon + text (Lexend Deca, Regular 400,
        // 14px/18px) (DASH-6077).
        <div className="flex items-center gap-2 rounded-xl bg-success-tint p-3">
          <CheckCircleIcon className="w-4 h-4 text-success-ink" />
          <span className="font-lexend text-[14px]/[18px] font-normal tracking-normal text-success-ink">
            {t("step.checked")}
          </span>
        </div>
      )}
      {/* Figma spec: Lexend Deca, Bold 700, 10px/12px, 0.6px letter-spacing,
          uppercase, ink/60 (#0F151A99) — same on mobile and desktop (DASH-6077). */}
      <span className="font-lexend text-[10px]/[12px] font-bold tracking-[0.6px] uppercase text-ink-60">
        {t("step.indicator", { current, total })}
      </span>
    </div>
  );
};
